import * as React from 'react';

import { useRouter } from 'next/router';

import { nonAuthenticatedRoutes } from '../utils/non-authenticated-routes';

type AuthenticatedRouteGuardProps = {
  children: React.ReactNode;
};

/**
 * Show children only if the current route requires authentication.
 */
export const AuthenticatedRouteGuard: React.FC<
  AuthenticatedRouteGuardProps
> = ({ children }) => {
  const router = useRouter();
  const isNonAuthenticatedRoute = nonAuthenticatedRoutes.has(router.pathname);

  if (isNonAuthenticatedRoute) {
    return null;
  }

  return <>{children}</>;
};
